/**
 * Schema of EmailAuditoria
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import EmailAuditoria from '@/model/resource/EmailAuditoria'

export default (model: EmailAuditoria): Schema => ({
  idEmailAuditoriaPk: {
    content: model.idEmailAuditoriaPk,
    editable: false,
  },

  nomeGrupo: {
    content: model.nomeGrupo,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  email: {
    content: model.emailAuditoriaNivel && model.emailAuditoriaNivel.email ? model.emailAuditoriaNivel.email : '-',
    input: InputType.TEXTAREA,
    meta: {
      required: true,
      selectAll: true,
    },
  },

  idEmailNivelFk: {
    content: model.emailAuditoriaNivel && model.emailAuditoriaNivel.emailNivel ?
        model.emailAuditoriaNivel.emailNivel.titulo : '-',
    input: InputType.NUMBER,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  idResponsavelFk: {
    content: model.idResponsavelFk,
    input: InputType.NUMBER,
  },

  ativo: {
    content: bool(model.emailAuditoriaNivel.ativo),
    input: InputType.CHECKBOX,
  },
})
